/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function XmarkIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m29.579 12.545-7.495 7.494 7.432 7.432a1.368 1.368 0 0 1 0 2.06 1.368 1.368 0 0 1-2.06 0L19.96 22.1l-7.432 7.432a1.368 1.368 0 0 1-2.06 0c-.625-.562-.625-1.5 0-2.124l7.431-7.431-7.432-7.432c-.624-.562-.624-1.499 0-2.123.562-.563 1.5-.563 2.124 0l7.431 7.494 7.432-7.432c.562-.625 1.499-.625 2.124 0a1.47 1.47 0 0 1 0 2.06"/>}
        </IconWrapper>);
}
